/** Phân quyền — nhóm hàng */
export const NHOM_HANG_PERMISSION_CODES = {
  WEB_BH_NHOM_HANG_LIST: 'WEB_BH_NHOM_HANG_LIST',
  WEB_BH_NHOM_HANG_DETAIL: 'WEB_BH_NHOM_HANG_DETAIL',
  WEB_BH_NHOM_HANG_ADD: 'WEB_BH_NHOM_HANG_ADD',
  WEB_BH_NHOM_HANG_EDIT: 'WEB_BH_NHOM_HANG_EDIT',
  WEB_BH_NHOM_HANG_DELETE: 'WEB_BH_NHOM_HANG_DELETE',
  WEB_BH_NHOM_HANG_IMPORT: 'WEB_BH_NHOM_HANG_IMPORT',
  WEB_BH_NHOM_HANG_EXPORT: 'WEB_BH_NHOM_HANG_EXPORT',
} as const

export const NHOM_HANG_READ_PERMISSIONS = [
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_LIST,
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_DETAIL,
] as const

export const NHOM_HANG_MUTATE_PERMISSIONS = [
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_ADD,
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_EDIT,
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_DELETE,
  NHOM_HANG_PERMISSION_CODES.WEB_BH_NHOM_HANG_IMPORT,
] as const
